module.exports = __webpack_public_path__ + "static/business_process_improvement-1d060a6fab29e315fdc9ae9c67249e62.jpg";